import AAVE from "src/assets/images/tokens/aave.svg";
import ADA from "src/assets/images/tokens/ADA.png";
import BTCB from "src/assets/images/tokens/BTCB.png";
import busd from "src/assets/images/tokens/busd.png";
import dai from "src/assets/images/tokens/dai.svg";
import DOT from "src/assets/images/tokens/DOT.png";
import usdc from "src/assets/images/tokens/usdc.svg";
import usdt from "src/assets/images/tokens/usdt.svg";
import BNB from "src/assets/images/tokens/BNB.png";
import XVS from "src/assets/images/tokens/xvs.svg";
import ETH from "src/assets/images/tokens/ETH.png";
import XRP from "src/assets/images/tokens/xrp.png";
import CAKE from "src/assets/images/tokens/cake.svg";
import DOGE from "src/assets/images/tokens/DOGE.png";
import TRAVA from "src/assets/images/tokens/Trava.png";
import TOD from "src/assets/images/tokens/tod.png";

const BscTestnetTokens = {
  "0xfccb260c9074fabb69702c1972aa747aac6e654f": {
    symbol: "DAI",
    image: dai,
    decimal: 18,
    loanToValue: 0.77,
    lt: 0.8,
    liquidationBonus: 0.05,
    reserveFactor: 0.15,
    utilizationOptimal: 0.8,
    slope1: 0.04,
    slope2: 0.75,
    baseInterestRate: 0,
    borrowingEnabled: true,
    oracle: { address: "0xE4eE17114774713d2De0eC0f035d4F7665fc025D", oracle: "chainlink" },
  },
  "0x345dcb7b8f17d342a3639d1d9bd649189f2d0162": {
    symbol: "USDC",
    image: usdc,
    decimal: 6,
    loanToValue: 0.8,
    lt: 0.85,
    liquidationBonus: 0.05,
    reserveFactor: 0.15,
    utilizationOptimal: 0.9,
    slope1: 0.04,
    slope2: 0.6,
    baseInterestRate: 0,
    borrowingEnabled: true,
    oracle: { address: "0x90c069C4538adAc136E051052E14c1cD799C41B7", oracle: "chainlink" },
  },
  "0x780397e17dbf97259f3b697ca3a394fa483a1419": {
    symbol: "USDT",
    image: usdt,
    decimal: 6,
    loanToValue: 0.75,
    lt: 0.8,
    liquidationBonus: 0.05,
    reserveFactor: 0.15,
    utilizationOptimal: 0.9,
    slope1: 0.04,
    slope2: 0.6,
    baseInterestRate: 0,
    borrowingEnabled: true,
    oracle: { address: "0xEca2605f0BCF2BA5966372C99837b1F182d3D620", oracle: "chainlink" },
  },
  "0xbe2a3b225ada4142c42a36cfbd5b04f28d261ca8": {
    symbol: "ETH",
    image: ETH,
    decimal: 18,
    loanToValue: 0.825,
    lt: 0.85,
    liquidationBonus: 0.05,
    reserveFactor: 0.15,
    utilizationOptimal: 0.65,
    slope1: 0.08,
    slope2: 1,
    baseInterestRate: 0,
    borrowingEnabled: true,
    oracle: { address: "0x143db3CEEfbdfe5631aDD3E50f7614B6ba708BA7", oracle: "chainlink" },
  },
  "0x910cb19698eac48a6ab7ccc9542b756f2bdd67c6": {
    symbol: "BNB",
    image: BNB,
    decimal: 18,
    loanToValue: 0.75,
    lt: 0.8,
    liquidationBonus: 0.05,
    reserveFactor: 0.15,
    utilizationOptimal: 0.65,
    slope1: 0.1,
    slope2: 1,
    baseInterestRate: 0,
    borrowingEnabled: true,
    oracle: { address: "0x2514895c72f50D8bd4B4F9b1110F0D6bD2c97526", oracle: "chainlink" },
  },
  "0x639138a1b91799944ad34355fd8d6a2d696c3ca9": {
    symbol: "BTCB",
    image: BTCB,
    decimal: 18,
    loanToValue: 0.7,
    lt: 0.75,
    liquidationBonus: 0.09,
    reserveFactor: 0.2,
    utilizationOptimal: 0.65,
    slope1: 0.07,
    slope2: 1,
    baseInterestRate: 0,
    borrowingEnabled: true,
    oracle: { address: "0x5741306c21795FdCBb9b265Ea0255F499DFe515C", oracle: "chainlink" },
  },
  "0x2cec38c779d6b962bc877777b6f70937d21c9c38": {
    symbol: "BUSD",
    image: busd,
    decimal: 18,
    loanToValue: 0.75,
    lt: 0.8,
    liquidationBonus: 0.05,
    reserveFactor: 0.15,
    utilizationOptimal: 0.8,
    slope1: 0.04,
    slope2: 1,
    baseInterestRate: 0,
    borrowingEnabled: true,
    oracle: { address: "0x9331b55D9830EF609A2aBCfAc0FBCE050A52fdEa", oracle: "chainlink" },
  },
  "0x45a80229e1feab61e360efa9005b5ab46821cee7": {
    symbol: "XVS",
    image: XVS,
    decimal: 18,
    loanToValue: 0.6,
    lt: 0.65,
    liquidationBonus: 0.05,
    reserveFactor: 0.2,
    utilizationOptimal: 0.65,
    slope1: 0.07,
    slope2: 1,
    baseInterestRate: 0,
    borrowingEnabled: true,
    oracle: { address: "0xCfA786C17d6739CBC702693F23cA4417B5945491", oracle: "chainlink" },
  },
  "0x0642e40c9a12fc3c7a3bffa47e9e41391cc49dbe": {
    symbol: "DOT",
    image: DOT,
    decimal: 18,
    loanToValue: 0.7,
    lt: 0.75,
    liquidationBonus: 0.05,
    reserveFactor: 0.2,
    utilizationOptimal: 0.65,
    slope1: 0.08,
    slope2: 1,
    baseInterestRate: 0,
    borrowingEnabled: true,
    oracle: { address: "0xEA8731FD0685DB8AeAde9EcAE90C4fdf1d8164ed", oracle: "chainlink" },
  },
  "0x3cb48b8e2ef30a8ad5130ad49b8a6044ea80d1f2": {
    symbol: "AAVE",
    image: AAVE,
    decimal: 18,
    loanToValue: 0.7,
    lt: 0.75,
    liquidationBonus: 0.05,
    reserveFactor: 0.15,
    utilizationOptimal: 0.65,
    slope1: 0.07,
    slope2: 1,
    baseInterestRate: 0,
    borrowingEnabled: true,
    oracle: { address: "0x298619601ebCd58d0b526963Deb2365B485Edc74", oracle: "chainlink" },
  },
  "0x5303a4c5c5d79d086c77e05338fdf6548a1ee09c": {
    symbol: "ADA",
    image: ADA,
    decimal: 18,
    loanToValue: 0.7,
    lt: 0.75,
    liquidationBonus: 0.05,
    reserveFactor: 0.2,
    utilizationOptimal: 0.65,
    slope1: 0.08,
    slope2: 1,
    baseInterestRate: 0,
    borrowingEnabled: true,
    oracle: { address: "0x5e66a1775BbC249b5D51C13d29245522582E671C", oracle: "chainlink" },
  },
  "0x97f04bf5fcff000e2bf72884e6c33a261f8e8ba9": {
    symbol: "CAKE",
    image: CAKE,
    decimal: 18,
    loanToValue: 0.7,
    lt: 0.75,
    liquidationBonus: 0.05,
    reserveFactor: 0.2,
    utilizationOptimal: 0.65,
    slope1: 0.08,
    slope2: 1,
    baseInterestRate: 0,
    borrowingEnabled: true,
    oracle: { address: "0x81faeDDfeBc2F8Ac524327d70Cf913001732224C", oracle: "chainlink" },
  },
  "0xb868dc5a295489088d3373ee8d365cef45c38684": {
    symbol: "XRP",
    image: XRP,
    decimal: 18,
    loanToValue: 0.7,
    lt: 0.75,
    liquidationBonus: 0.05,
    reserveFactor: 0.2,
    utilizationOptimal: 0.65,
    slope1: 0.08,
    slope2: 1,
    baseInterestRate: 0,
    borrowingEnabled: true,
    oracle: { address: "0x4046332373C24Aed1dC8bAd489A04E187833B28d", oracle: "chainlink" },
  },
  "0xe4c7e2f0d19335f9b85e4732eb05efced2f8f2fb": {
    symbol: "DOGE",
    image: DOGE,
    decimal: 18,
    loanToValue: 0.55,
    lt: 0.6,
    liquidationBonus: 0.08,
    reserveFactor: 0.2,
    utilizationOptimal: 0.6,
    slope1: 0.8,
    slope2: 1.5,
    baseInterestRate: 0,
    borrowingEnabled: true,
    oracle: { address: "0x963D5e7f285Cc84ed566C486c3c1bC911291be38", oracle: "chainlink" },
  },
  "0xe1f005623934d3d8c724ec68cc9bfd95498d4435": {
    symbol: "TRAVA",
    image: TRAVA,
    decimal: 18,
    loanToValue: 0.7,
    lt: 0.75,
    liquidationBonus: 0.05,
    reserveFactor: 0.15,
    utilizationOptimal: 0.65,
    slope1: 0.07,
    slope2: 1,
    baseInterestRate: 0,
    borrowingEnabled: true,
    oracle: { address: "0x85b6EDc7700e51563faEA7d45Ad2B30eEe1C3456", oracle: "pairBNB" },
  },
  "0xfca3cf5e82f595d4f20c24d007ae5e2e94fab2f0": {
    symbol: "TOD",
    image: TOD,
    decimal: 18,
    loanToValue: 0.7,
    lt: 0.75,
    liquidationBonus: 0.05,
    reserveFactor: 0.15,
    utilizationOptimal: 0.65,
    slope1: 0.07,
    slope2: 1,
    baseInterestRate: 0,
    borrowingEnabled: true,
    oracle: { address: "0x95B77e6cc1F374b0D5Fc46F161249e3651F530c0", oracle: "pairBNB" },
  },
};

export default BscTestnetTokens;
